import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import TagHistoryContainer from '../../containers/tag/TagHistoryContainer';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';

const TagHistory = () => {
  return (
    <PageTemplate pageName={TAG_PAGE_NAME.TAG_HISTORY}>
      <TagHistoryContainer />
    </PageTemplate>
  );
};

export default TagHistory;
